import type { JSX } from "react";

import { CustomerVerificationView } from "./CustomerVerificationView";
import { useCustomerVerification } from "./hooks/useCustomerVerification";

export interface CustomerVerificationProps {
    mdnFromTask: string;
    isPreviousSessionSummaryEnabled: boolean;
}

export function CustomerVerification({
    mdnFromTask,
    isPreviousSessionSummaryEnabled,
}: CustomerVerificationProps): JSX.Element {
    const viewProps = useCustomerVerification({
        mdnFromTask,
        isPreviousSessionSummaryEnabled,
    });

    return <CustomerVerificationView {...viewProps} />;
}
